/**
 * Combines numerous FloorData Collections to one
 * @param data
 * @returns
 */
export const mergeGeoJSONData = (data) => {
    const combinedCollection = {
        ground: [],
        rooms: [],
        outlines: [],
        floors: [],
        buildings: [],
        details: [],
        masks: [],
        walls: [],
    };
    data.forEach((collection) => {
        if (collection == null)
            return;
        for (const key in collection) {
            const value = collection[key];
            // check if FeatureCollection, Feature[] or null
            if (!value) {
                continue;
            }
            let features = [];
            if (!Array.isArray(value)) {
                // FeatureCollection
                if (Array.isArray(value.features)) {
                    features = value.features;
                }
                else {
                    console.warn("No valid FeatureCollection given; Value in Collection:", value);
                }
            }
            else {
                // Feature[]
                features = value;
            }
            if (combinedCollection[key] != null) {
                combinedCollection[key] = combinedCollection[key].concat(features);
            }
        }
    });
    return combinedCollection;
};
